import {Table, Typography} from 'antd';
import {CardProps} from 'antd/es/card';
import {ColumnProps} from 'antd/lib/table';
import {AddressFieldsFragment, Store, useStoresQuery} from 'api/generated';
import {TableCard} from 'components/TableCard';
import {useTableSearch} from 'hooks/useTableSearch';
import {truncate} from 'lib/utils';
import React, {useEffect, useState} from 'react';
import {formatAddress, formatIBAN} from '../../../lib/formaters';
import {StoresActions} from './StoresActions';
import {CreateStore} from './CreateStore';

const {Text} = Typography;

export type StoresProps = {
  stores: Store[];
  loadingStores: boolean;
};

export type Props = {
  accountId: string;
  cardProps: CardProps;
};

export const Stores: React.FC<Props> = ({accountId, cardProps}) => {
  const {data, loading} = useStoresQuery({variables: {accountId}});

  const [from, setFrom] = useState(0);
  const [total, setTotal] = useState(0);
  const [size, setSize] = useState(20);

  const [stores, setStores] = useState<Store[]>([]);

  useEffect(() => {
    setStores(data?.stores.items || []);
    setTotal(data?.stores.items.length || 0);
  }, [data]);

  const columns: Array<ColumnProps<Store>> = [
    useTableSearch({
      title: 'Name',
      dataIndex: 'name'
    }),
    {
      title: 'Address',
      dataIndex: 'address',
      render: (value: AddressFieldsFragment) => {
        return <>{value && formatAddress(value)}</>;
      }
    },
    {
      title: 'IBAN',
      dataIndex: 'iban',
      render: (iban: string) => formatIBAN(iban, true)
    },
    {
      title: 'Store ID',
      dataIndex: 'id',
      className: 'minimized-cell',
      render(id: string) {
        return <Text copyable={{text: id}}>{truncate(id, 15)}</Text>;
      }
    },
    {
      key: 'actions',
      align: 'right',
      className: 'minimized-cell',
      render: (_, store) => <StoresActions store={store} />
    }
  ];

  return (
    <TableCard title="Stores" extra={<CreateStore accountId={accountId} />} {...cardProps}>
      <Table
        rowKey="id"
        scroll={{x: true}}
        dataSource={stores}
        columns={columns as any}
        loading={loading}
        pagination={{
          total,
          pageSize: size,
          hideOnSinglePage: true,
          current: from / size + 1,
          onShowSizeChange: (current, pageSize) => {
            setSize(pageSize);
            setFrom((current - 1) * pageSize);
          },
          onChange: (page, size = 0) => setFrom((page - 1) * size)
        }}
      />
    </TableCard>
  );
};
